import { render, staticRenderFns } from "./cobranzasChequesNuevo.vue?vue&type=template&id=5b574883&scoped=true"
import script from "./cobranzasChequesNuevo.vue?vue&type=script&lang=js"
export * from "./cobranzasChequesNuevo.vue?vue&type=script&lang=js"
import style0 from "./cobranzasChequesNuevo.vue?vue&type=style&index=0&id=5b574883&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b574883",
  null
  
)

export default component.exports